// TrackBusPage.jsx
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./trackBusPage.scss";

const TrackBusPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { trackUrl } = location.state || {};

  return (
    <div className="trackPageContainer">
      
      {/* Header */}
      <div className="trackHeader">
        <button className="backBtn" onClick={() => history.goBack()}>
          ←
        </button>
        <span className="title">Track Bus</span>
      </div>

      {/* Webpage */}
      <iframe
        src={trackUrl}
        title="Track Bus"
        className="trackIframe"
      />
    </div>
  );
};

export default TrackBusPage;